<template>
  <section
    class="mx-auto mt-16 max-w-5xl px-4 text-[#15120f] sm:px-0"
    :aria-labelledby="`${product}-specs-title`"
  >
    <p class="text-[0.62rem] uppercase tracking-[0.32em] text-black/38">{{ copy.eyebrow }}</p>
    <h2 :id="`${product}-specs-title`" class="mt-3 font-['Playfair_Display'] text-[2rem] leading-tight text-black sm:text-[2.6rem]">
      {{ copy.title }}
    </h2>
    <dl class="mt-8 divide-y divide-black/10 border-y border-black/10">
      <div v-for="row in copy.rows" :key="row.label" class="grid gap-1 py-4 sm:grid-cols-[minmax(0,0.32fr)_minmax(0,0.68fr)] sm:gap-6">
        <dt class="text-[0.7rem] uppercase tracking-[0.24em] text-black/45">{{ row.label }}</dt>
        <dd class="text-[0.98rem] leading-[1.7] text-black/78">{{ row.value }}</dd>
      </div>
    </dl>
  </section>
</template>

<script setup lang="ts">
import { productSeoContent, type ProductSeoType } from '~/utils/productSeoContent'

const props = defineProps<{ product: ProductSeoType }>()
const siteLocale = useSiteLocale()
const copy = computed(() => productSeoContent[props.product].specs[siteLocale.value === 'fr' ? 'fr' : 'en'])
</script>
